module.exports = __webpack_public_path__ + "static/img/delivery.61f84f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/set-lessor/delivery.png
// module id = 4Zrc
// module chunks = 0